/**
 * One warning per layer when Auto Numbering is on but has no starting number.
 *
 * WHY THIS EXISTS. `addCue` skips auto-numbering when the layer's seed is
 * missing or invalid, and until 14 Sept 2026 it did so in complete silence: the
 * cue was created with an empty number field and nothing said why. The layer
 * editor's "Enter a number to begin auto-numbering" is the right message in the
 * wrong place -- that panel is closed by the time anyone is adding cues.
 *
 * Switching the toggle on now seeds the field automatically, so the only way to
 * reach this state is to clear the seed afterwards. Rare, but silent failure is
 * exactly what it was before.
 *
 * ⚠ ONCE PER LAYER, not once per cue. Someone laying in a run of cues would
 * otherwise get a toast for every one of them, which is its own friction and
 * teaches people to dismiss toasts without reading.
 *
 * Keyed by project AND layer so switching projects warns again -- the same layer
 * id cannot recur across projects, but the pairing makes the intent explicit and
 * the reset cheap.
 */

const warned = new Set();

const key = (projectID, layerID) => `${projectID}:${layerID}`;

/** True the FIRST time a given layer hits this, false every time after. */
export function shouldWarnNoSeed(projectID, layerID) {
    const k = key(projectID, layerID);
    if (warned.has(k)) return false;
    warned.add(k);
    return true;
}

/** Call when a seed is set again, so a later lapse warns afresh. */
export function clearNoSeedWarning(projectID, layerID) {
    warned.delete(key(projectID, layerID));
}

export default { shouldWarnNoSeed, clearNoSeedWarning };


// WEBPACK FOOTER //
// ./src/lib/autoNumberWarning.js